import { SupportingContent } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useInviteModalActions } from "shared-ui";

import { COMMON_MESSAGES } from "../../common-messages";

import { MESSAGES } from "./message-definitions";

export const RevenueSourceSecondaryContent = () => {
  const intl = useIntl();
  const { openInviteModal } = useInviteModalActions();
  const openInviteModalHandler = () => {
    openInviteModal();
  };

  return (
    <>
      <SupportingContent
        faqItems={[
          {
            question: intl.formatMessage(MESSAGES.faqWhyDoYouNeedMyDataQuestion),
            answer: intl.formatMessage(MESSAGES.faqWhyDoYouNeedMyDataAnswer),
          },
        ]}
        securityInfo={{
          label: intl.formatMessage({
            id: "funding-application: data security statement",
            defaultMessage: "Your data is securely stored in encrypted databases",
          }),
          link: {
            external: true,
            linkText: intl.formatMessage(COMMON_MESSAGES.viewOurPrivacyNotice),
            url: "https://www.wayflyer.com/privacy-notice",
          },
        }}
        supportingLinks={{
          heading: intl.formatMessage({
            id: "funding-application: unable to connect",
            defaultMessage: "Unable to connect?",
          }),
          links: [
            {
              linkText: intl.formatMessage({
                id: "funding-application: invite team member",
                defaultMessage: "Invite a team member to connect an account for you",
              }),
              onClick: openInviteModalHandler,
            },
            {
              external: true,
              url: "https://help-center.wayflyer.com/en/collections/152000-connecting-your-platforms",
              linkText: intl.formatMessage({
                id: "funding-application: learn more about connecting",
                defaultMessage: "Learn more about connecting accounts in our Help Center",
              }),
            },
          ],
        }}
      />
    </>
  );
};
